import * as React from 'react';
import classNames from 'classnames';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {Text} from 'components/UIKit';
import * as locales from '../locales';
import {ListingSummary} from '../../ListingSummary';
import styles from '../SimilarListings.scss';
import {ListingShop} from '../../../types';

export interface SimilarListingProps {
  last?: boolean;
  listing: ListingShop;
  reference: any;
  showComparison?: boolean;
  onCompareClick: (listing: any) => void;
}

class SimilarListingComponent extends React.Component<SimilarListingProps & WithI18nProps> {
  renderTopButton = () => {
    const {showComparison = false, i18n} = this.props;

    return (
      <Text
        type="link"
        text={i18n.translate(showComparison ? 'close' : 'compare')}
        component="button"
        onClick={this.handleCompareClick}
        className={styles.Toggle}
        secondary={Boolean(showComparison)}
        resetMargin
      />
    );
  };

  renderReferenceFooter = () => {
    const {i18n} = this.props;
    return (
      <Text
        type="legal"
        text={i18n.translate('referenceFooter')}
        resetMargin
        className={styles.LegalFooter}
      />
    );
  };

  renderReferenceSubHeader = () => {
    const {i18n} = this.props;

    return (
      <Text type="legal" text={i18n.translate('referenceSubHeader')} className={styles.Subheader} />
    );
  };

  handleCompareClick = () => {
    const {listing, onCompareClick} = this.props;

    onCompareClick(listing);
  };

  render() {
    const {last = false, listing, reference, showComparison = false} = this.props;

    return (
      <li
        className={classNames(styles.Container, {
          [styles.Compare]: showComparison,
        })}
      >
        <ListingSummary
          linkTo
          hideBorder={last && !showComparison}
          listing={listing}
          showMetrics={showComparison}
          renderTopButton={this.renderTopButton}
        />
        {showComparison ? (
          <ListingSummary
            hideBorder
            showMetrics
            listing={reference}
            renderFooter={this.renderReferenceFooter}
            renderSubHeader={this.renderReferenceSubHeader}
          />
        ) : null}
      </li>
    );
  }
}

export const SimilarListing = withI18n({
  id: 'SimilarListings',
  fallback: locales.en,
})(SimilarListingComponent);

export default SimilarListing;
